module.exports = __webpack_public_path__ + "static/img/img_awards_3.7949f53.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/aboutUs/img_awards_3.png
// module id = HX9t
// module chunks = 15